import api from './api.service'

export const customerStatisticsService = {
    findAllDocumentationsByCustomerId,
    findAllTemplatesByCustomerId,
    findAllPhotosByCustomerId
};

const BASE_URL = '/customerStatistics'

function findAllDocumentationsByCustomerId(customerId) {
    return api.get(BASE_URL + '/findAllDocumentationsByCustomerId/' + customerId)
}

function findAllTemplatesByCustomerId(customerId) {
    return api.get(BASE_URL + '/findAllTemplatesByCustomerId/' + customerId)
}

function findAllPhotosByCustomerId(customerId) {
    return api.get(BASE_URL + '/findAllPhotosByCustomerId/' + customerId)
}